import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Apiservice from "../Apiservice";

const StaffEdit = () => {
    const { user_id } = useParams();
    const navigate = useNavigate();
    const [roles, setRoles] = useState([]);
    const [sites, setSites] = useState([]);
    const [profileImage, setProfileImage] = useState(null);
    const [preview, setPreview] = useState("");
    const [errors, setErrors] = useState({});
    // const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);

    const firstNameRef = useRef("");
    const lastNameRef = useRef("");
    const site_idRef = useRef("");
    const role_idRef = useRef("");
    const dateOfJoinRef = useRef("");
    const employeeIdRef = useRef("");
    const nricOrFinRef = useRef("");
    const profileImageRef = useRef(null);
    const countryCodeRef = useRef("+65");
    const mobileNoRef = useRef("");
    const emailIdRef = useRef("");
    const userNameRef = useRef("");
    const passwordRef = useRef("");
    const unitNoRef = useRef("");
    const streetRef = useRef("");
    const countryRef = useRef("");
    const pincodeRef = useRef("");

    const [role_id, setRoleId] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const token = localStorage.getItem("access_token");
                const headers = { access_token: token };
                const userResult = await Apiservice.GetUserById({ user_id: user_id, status: 0 }, headers);
                if (userResult.success) {
                    const userData = userResult.data[0];
                    // setUserData(userData);
                    setLoading(false)
                    if (userData) {
                        setRoleId(userData.role_id || "");

                        firstNameRef.current.value = userData.firstName || "";
                        lastNameRef.current.value = userData.lastName || "";
                        site_idRef.current.value = userData.site_id || "";
                        dateOfJoinRef.current.value = userData.dateOfJoin || "";
                        employeeIdRef.current.value = userData.employeeId || "";
                        nricOrFinRef.current.value = userData.nricOrFin || "";
                        countryCodeRef.current.value = userData.countryCode || "+65";
                        mobileNoRef.current.value = userData.mobileNo || "";
                        emailIdRef.current.value = userData.emailId || "";
                        userNameRef.current.value = userData.userName || "";
                        passwordRef.current.value = userData.password || "";
                        unitNoRef.current.value = userData?.address?.[0]?.unitNo || "";
                        streetRef.current.value = userData?.address?.[0]?.street || "";
                        countryRef.current.value = userData?.address?.[0]?.country || "";
                        pincodeRef.current.value = userData?.address?.[0]?.pincode || "";

                        setProfileImage(userData?.profileImage || "");
                        setPreview(userData?.profileImage || "");

                        const imageUrl = userData.profileImage || null;
                        setPreview(imageUrl);

                        setSites(userData.sites);

                    }


                } else {
                    alert(userResult.message);
                }

                const roleResult = await Apiservice.GetAllRoles(headers);
                if (roleResult.success) {
                    setRoles(roleResult.data);
                } else {
                    alert(roleResult.message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [user_id]);

    const handleFileChange = (e) => {
        const file = e.target.files[0]; // Get the file object
        setProfileImage(file);

        // Generate a preview URL using FileReader
        const reader = new FileReader();
        reader.onloadend = () => {
            setPreview(reader.result); // Set the preview URL
        };
        if (file) {
            reader.readAsDataURL(file); // Convert file to base64 URL
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!firstNameRef.current.value.trim()) {
            newErrors.firstName = "First Name is required";
        }

        // if (!lastNameRef.current.value.trim()) {
        //     newErrors.lastName = "Last Name is required";
        // }

        if (!role_id) {  // Use role_id state directly here
            newErrors.role_id = "Designation is required";
        }
        if (!dateOfJoinRef.current.value) {
            newErrors.dateOfJoin = "Date of Join is required";
        }

        // if (!unitNoRef.current.value || isNaN(unitNoRef.current.value)) {
        //     newErrors.unitNo = "Unit Level is required and must be a number";
        // }

        if (!unitNoRef.current.value) {
            newErrors.unitNo = "Unit Level is required";
        }

        if (!streetRef.current.value.trim()) {
            newErrors.street = "Street is required";
        }

        if (!countryRef.current.value.trim()) {
            newErrors.country = "Country is required";
        }

        const pincode = pincodeRef.current?.value?.trim(); // remove spaces

        if (!pincode || isNaN(pincode) || parseInt(pincode) <= 0) {
            newErrors.pincode = "Pincode is required";
        }

        if (emailIdRef.current.value.length > 0) {
            if (!emailIdRef.current.value.trim() || !/\S+@\S+\.\S+/.test(emailIdRef.current.value)) {
                newErrors.emailId = "Valid Email is required";
            }
        }

        if (!mobileNoRef.current.value.trim() || isNaN(mobileNoRef.current.value)) {
            newErrors.mobileNo = "Valid Contact Number is required";
        }

        if (!userNameRef.current.value.trim()) {
            newErrors.userName = "User ID is required";
        }

        if (!passwordRef.current.value.trim()) {
            newErrors.password = "Password is required";
        }

        // if (!profileImage && !userData?.profileImage) {  // Check if no profile image is selected
        //     newErrors.profileImage = "Profile Image is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        // if (!profileImage) {
        //     alert("Please select an image first.");
        //     return;
        // }

        const formData = new FormData();
        formData.append("user_id", user_id);
        formData.append("firstName", firstNameRef.current.value);
        formData.append("lastName", lastNameRef.current.value);
        formData.append('site_id', site_idRef.current.value || 0);
        formData.append("role_id", role_id);  // Use role_id state directly
        formData.append('dateOfJoin', dateOfJoinRef.current.value || null)
        formData.append("employeeId", employeeIdRef.current.value);
        formData.append("nricOrFin", nricOrFinRef.current.value);
        formData.append("countryCode", countryCodeRef.current.value);
        formData.append("mobileNo", mobileNoRef.current.value);
        formData.append("emailId", emailIdRef.current.value);
        formData.append("userName", userNameRef.current.value);
        formData.append("password", passwordRef.current.value);
        formData.append("unitNo", unitNoRef.current.value);
        formData.append("street", streetRef.current.value);
        formData.append("country", countryRef.current.value);
        formData.append("pincode", pincodeRef.current.value);
        formData.append("status", 0);

        if (profileImage) {  // Append the new profile image if selected
            formData.append("profileImage", profileImage);
        }

        const token = localStorage.getItem("access_token");
        const headers = { access_token: token };

        try {
            const result = await Apiservice.UpdateUser(formData, headers);
            if (result.success) {
                navigate("/allstaff");
            } else {
                alert(result.message);
            }
        } catch (err) {
            console.error(err);
            alert(err.message);
        }
    };

    return (
        <div className="container-fluid p-md-2 p-0" style={{ backgroundColor: "white", userSelect: 'none' }}>
            {/* {
                loading ? (
                    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                        <div className="text-center">
                            
                            <div
                                className="spinner-border text-primary"
                                role="status"
                                style={{
                                    width: "2rem",
                                    height: "2rem",
                                    borderWidth: "3px",
                                }}
                            >
                                <span className="visually-hidden">Loading...</span>
                            </div>
                          
                            <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                        </div>
                    </div>
                )
                    :
                    ( */}
            <>
                <div className="row mb-1">
                    <div className="col text-center">
                        <h4>Edit Employee</h4>
                    </div >
                </div >

                <div className="row p-md-2 m-md-2">
                    <div className="col-md-8">
                        <div className="form">
                            {Object.entries({
                                firstName: "First Name",
                                lastName: "Last Name",
                                site_id: "Site",
                                role_id: "Designation",
                                dateOfJoin:"Date of Join",
                                employeeId: "Employee ID",
                                nricOrFin: "NRIC / FIN",
                                unitNo: "Unit Level",
                                street: "Street",
                                country: "Country",
                                pincode: "Pincode",
                                emailId: "Email",
                                mobileNo: "Contact No.",
                                userName: "User ID",
                                password: "Password",
                                profileImage: "Photo",
                            }).map(([key, label]) => (
                                <div className="row mb-2" key={key}>
                                    <div className="col-3">
                                        <label htmlFor={key} className="form-label">
                                            {label}
                                        </label>
                                    </div>
                                    <div className="col-1">:</div>
                                    <div className="col">
                                        {key === "profileImage" ? (
                                            <input
                                                type="file"
                                                accept="image/*"
                                                // className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                className="form-control form-control-sm"
                                                onChange={handleFileChange}
                                                ref={profileImageRef}
                                            />
                                        ) : key === "site_id" ? (
                                            <select
                                                className={`form-select form-select-sm ${errors[key] ? "is-invalid" : ""}`}
                                                ref={site_idRef}
                                            >
                                                <option value="">Select the Site</option>
                                                {sites.length > 0 ? (
                                                    sites.map((site) => (
                                                        <option key={site.id} value={site.id}>
                                                            {site.name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="">No Sites available</option>
                                                )}
                                            </select>
                                        ) : key === "role_id" ? (
                                            <select
                                                className={`form-select form-select-sm ${errors[key] ? "is-invalid" : ""}`}
                                                value={role_id}
                                                onChange={(e) => setRoleId(e.target.value)}
                                            >
                                                <option value="">Select the Designation</option>
                                                {roles.length > 0 ? (
                                                    roles.map((role) => (
                                                        <option key={role.id} value={role.id}>
                                                            {role.name}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="">No roles available</option>
                                                )}
                                            </select>
                                        ) : key === "dateOfJoin" ? (
                                            <div className="row">
                                                <div className="col">
                                                    <input
                                                        type="date"
                                                        className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                        ref={dateOfJoinRef}
                                                    // value={dateOfJoin}
                                                    // onChange={(e)=>setDateOfJoin(e.target.value)}
                                                    />
                                                    {errors[key] && <div className="invalid-feedback">{errors[key]}</div>}
                                                </div>

                                            </div>
                                        )
                                            : key === "mobileNo" ? (
                                                <div className="row">
                                                    <div className="col-md-3 mb-1">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            defaultValue="+65"
                                                            ref={countryCodeRef}
                                                            readOnly
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                            ref={mobileNoRef}
                                                        />
                                                    </div>
                                                </div>
                                            ) : key === "pincode" ? (
                                                <div className="row">

                                                    <div className="col">
                                                        <input
                                                            type="number"
                                                            className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                            ref={pincodeRef}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <input
                                                    type="text"
                                                    className={`form-control form-control-sm ${errors[key] ? "is-invalid" : ""}`}
                                                    ref={{
                                                        firstName: firstNameRef,
                                                        lastName: lastNameRef,
                                                        role_id: role_idRef,
                                                        employeeId: employeeIdRef,
                                                        nricOrFin: nricOrFinRef,
                                                        unitNo: unitNoRef,
                                                        street: streetRef,
                                                        country: countryRef,
                                                        emailId: emailIdRef,
                                                        mobileNo: mobileNoRef,
                                                        userName: userNameRef,
                                                        password: passwordRef,
                                                    }[key]}
                                                />
                                            )}
                                        {errors[key] && <div className="invalid-feedback">{errors[key]}</div>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-4 text-center">
                        {preview ? (
                            <img
                                src={preview}
                                alt="Preview"
                                className="img-fluid border"
                                style={{ maxWidth: "100%", maxHeight: "200px" }}
                            />
                        ) : (
                            <div>No image selected</div>
                        )}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col text-center">
                        <button className="btn btn-primary btn-sm" onClick={handleSubmit}>
                            Save
                        </button>
                    </div>
                </div>
            </>
            {/*          )
             } */}
        </div >
    );
};

export default StaffEdit;
